<script>
	import { db } from '../../firebase';
	import { ideas, stackIndex, restart } from '../../store';
    
	// import Cardstack from '../../components/organisms/CardStack/CardStack.svelte';
	import CardSlider from '../../components/organisms/CardSlider/CardSlider.svelte';
	import Toast from '../../components/molecules/Toast/Toast.svelte'

	let initialFetch = true;
	let loading = false;
	let startOver;

	// get public, highlighted (curated) ideas
	const query = db.collection('ideas')
							.where('isPublic', '==', true)
							.where('isSecured', '==', true)
							.where('isHighlight', '==', true)
							.orderBy('timestamp', 'desc')

	// real time listener to notify about new entries. mutation listeners are already handeled by the listener in App.svelte
	query.onSnapshot((snapshot) => {
		snapshot.docChanges().forEach((change) => {
			if (change.type === "added") {
				// console.log('New highlight added:', change.doc.data())
				// this check ensures, that the store is not messed up on mount / initially. only if new ideas appear afterwards
				if(initialFetch) return;
				if(change.doc.id in $ideas.highlights.entries === false) {
					if(Object.keys($ideas.highlights.updates).length) {
						$ideas.highlights.updates = Object.assign({[change.doc.id]: change.doc.data()}, $ideas.highlights.updates);
					} else {
						$ideas.highlights.updates = Object.assign({[change.doc.id]: change.doc.data()}, $ideas.highlights.entries);
					}
				}
			}
			if (change.type === "removed") {
				if(change.doc.id in $ideas.highlights.entries) $ideas.highlights.entries = delete $ideas.highlights.entries[change.doc.id] && $ideas.highlights.entries;
			}
		})
		// set initialFetch to false after first batch has been loaded.
		initialFetch = false;
	})
	
				// get public secured ideas by saveCount
	if(!$ideas.highlights.query) { 
		$ideas.highlights.query = query.limit(25);
		loading = true;
		getBatch();
	}
	
	function getBatch () {
		$ideas.highlights.query.get()
		.then((querySnapshot) => {
			const lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
			if(lastVisible) {
				$ideas.highlights.query = $ideas.highlights.query.startAfter(lastVisible);
				querySnapshot.forEach((doc) => {
					$ideas.highlights.entries[doc.id] = doc.data();
				});
			}
		}).then(() => {
			loading = false;
		})
		.catch((error) => {
			loading = false;
			console.log(error)
		})
	}

	function loadLatest () {
		$ideas.highlights.entries = $ideas.highlights.updates;
		$ideas.highlights.updates = {};
		$restart = true;
		onLatestLoaded();
	}

	function onLatestLoaded () {
		startOver()
	}

	$: if($stackIndex.highlights === Object.keys($ideas.highlights.entries).length - 5) getBatch(); // start fetching new content when reaching the 5th last slide

</script>

<div>
	{#if Object.keys($ideas.highlights.updates).length}
		<Toast on:loadLatest={loadLatest}/>
	{/if}
	<!-- <Cardstack page="feed" tab="highlights" /> -->
	<CardSlider bind:startOver {loading} page="feed" tab="highlights" />
</div>

<style>
	div {
		position: relative;
		display: flex;
		flex-direction: column;
		flex: 1;
	}
</style>